<template>
    <sp-form
        class="mobile-general-form-input"
        :class="`uuid-${config.uuid} ${globalModel.preview ? 'preview-text' : ''} ${notChanged ? 'disable-opacity' : ''}`"
        ref="elForm"
        v-show="!props.hide"
        :model="formModel"
        :rules="rules"
        @submit.native.prevent
    >
        <div @click="onClickForm">
            <sp-form-item prop="inputValue">
                <Formable v-if="!globalModel.preview" :label="i18nLabel" :is-required="props.required">
                    <div @click="onClickForm">
                        <input
                            v-show="!showPlaceHolder"
                            class="spc-form-input"
                            type="text"
                            :id="`_text_input_${config.uuid}`"
                            :value="formModel.inputValue"
                            :disabled="notChanged"
                            @input="onInput"
                            @focus="clickFormItemLog"
                            @blur="onInputBlur"
                        />
                    </div>
                    <div class="place-holder" v-show="showPlaceHolder" @click="onPlaceHolderClick">
                        <span>{{ formattedPlaceholder }}</span>
                    </div>
                    <div
                        v-if="props.exampleSettings && !globalModel.preview && !globalModel.hideSubmitStyle"
                        class="example-btn"
                        @click="onCheckExample"
                    >
                    </div>
                </Formable>
                <!-- 预览时的效果 -->
                <PreviewText
                    v-else
                    :labelText="i18nLabel"
                    :textDesc="formModel.inputValue"
                ></PreviewText>
            </sp-form-item>
            <picker-panel v-model="panelShow" title="示例图">
                <file-example @confirm="onCheckExample" :exampleData="props.exampleSettings"></file-example>
            </picker-panel>
        </div>
        <sub-title class="mt18 error-right" v-if="lastShowRejectTip(i18nLabel)" :errorMsg="outputError(i18nLabel)"></sub-title>
    </sp-form>
</template>
<script>
import { Form, FormItem } from '@ks/sharp-ui';
import Formable from '@ks/sharp-comp-formable';
import FileExample from '../component-base/common/file-example';
import PickerPanel from '../component-base/common/picker-panel';
import '@ks/sharp-comp-form-input/lib/themes/default/index.css';
import ComponentBase from '../component-base';
import { component } from './props';
import PreviewText from '../component-base/common/preview-text';
import formEventBus, { FORM_EVENTS_TYPE } from '../../utils/event-bus';
import SubTitle from '../component-base/common/sub-title';

export default {
    name: component,
    components: {
        SpForm: Form,
        SpFormItem: FormItem,
        Formable,
        PreviewText,
        PickerPanel,
        FileExample,
        SubTitle,
    },
    extends: ComponentBase,
    data() {
        return {
            formModel: {
                inputValue: '',
            },
            inputFocused: false,
            panelShow: false,
        };
    },
    computed: {
        rules() {
            const rules = [];
            const validator = this.props.consistenceSettings;
            if (validator) {
                rules.push({ validator: this.validateConsistence });
            }
            // 最小长度
            if (this.props.min) {
                rules.push({
                    type: 'string',
                    min: +this.props.min,
                    message: this.i18n(this.props.errMin, this.i18nLabel, this.props.min)
                        || `${this.i18nLabel}长度不能小于${this.props.min}`,
                });
            }
            // 最大长度
            if (this.props.max) {
                rules.push({
                    type: 'string',
                    max: +this.props.max,
                    message: this.i18n(this.props.errMax, this.i18nLabel, this.props.max)
                        || `${this.i18nLabel}长度不能大于${this.props.max}`,
                });
            }
            // 正则表达式
            if (this.props.pattern) {
                try {
                    const regExp = new RegExp(this.props.pattern);
                    rules.push({
                        pattern: regExp,
                        message: this.i18n(this.props.errPattern, this.i18nLabel)
                            || `${this.i18nLabel}格式不合规`,
                    });
                } catch (e) {
                    this.warn(e);
                }
            }
            return {
                inputValue: this.composeRules(this.props, { otherRules: rules }),
            };
        },
        showPlaceHolder() {
            return !this.inputFocused && !this.formModel.inputValue && !this.selfDisabled && this.props.placeholder;
        },
        formattedPlaceholder() {
            return this.i18n(this.props.placeholder).replace('$', '') || '';
        },
        logParams() {
            return {
                item_title: this.i18nLabel,
                item_info: this.formModel.inputValue === '' ? -1 : this.formModel.inputValue,
                is_connect_ocr: this.props.ocrConfig && this.props.ocrConfig.ocrKey ? 1 : 0,
            };
        },
    },
    methods: {
        // 一致性校验
        validateConsistence(rule, value, callback) {
            const { component, errorMsg, data, key } = this.props.consistenceSettings;
            let inputData;
            try {
                // 校验其他input组件的值
                inputData = this.getValueById(component, 'value');
            } catch (e) {
                callback(new Error(errorMsg));
                return;
            }
            if (inputData !== value) {
                callback(new Error(errorMsg));
            } else {
                callback();
            }
        },
        onCheckExample() {
            this.panelShow = !this.panelShow;
        },
        onPlaceHolderClick() {
            this.inputFocused = true;
            this.$nextTick(() => {
                const input = document.getElementById(`_text_input_${this.config.uuid}`);
                input && input.focus();
            });
        },
        onInputBlur() {
            this.inputFocused = false;
        },
        onInput($event) {
            const value = $event.target.value;
            // this.formModel.inputValue = this.props.trim ? value.trim() : value;
            this.formModel.inputValue = value;
            if (this.props.trim) {
                this.formModel.inputValue = value.trim();
            }
            this.onInputValueChange(this.formModel.inputValue);
            this.$emit('user-input');
        },
        onInputValueChange(val) {
            const res = this.setSelfFormDataValue(val);
            if (res) {
                // 数据修改成功，抛出change事件，触发依赖
                this.$emit('change');
            }
        },
        clickFormItemLog() {
            this.inputFocused = true;
            formEventBus.$emit(FORM_EVENTS_TYPE.SEND_FORM_LOG, 'CLICK', 'COLLECT_INFORMATION_ITEM', this.logParams);
        },
        /**
         * 以下是组件公共方法的实现
         */
        dataChangeHandler() {
            const newValue = this.getSelfFormDataValue();
            if (typeof newValue === 'undefined') {
                // 默认值逻辑
                this.formModel.inputValue = '';
                this.onInputValueChange('');
                // this.validate();
                return;
            }

            if (this.formModel.inputValue !== newValue) {
                this.formModel.inputValue = newValue;
                // 数据被动修改同样抛出change事件
                this.$emit('change');
                // this.validate();
            }
        },
        async validate() {
            if (this.skipValidate()) {
                return true;
            }
            const promise = new Promise((resolve, reject) => {
                this.$refs.elForm.validate((valid, invalidFields) => {
                    valid ? resolve(valid) : reject(invalidFields);
                });
            });
            try {
                return await promise;
            } catch (e) {
                this.validateFailureHandler(e.inputValue[0].message);
                return false;
            }
        },
        clearValidate() {
            this.$refs.elForm.clearValidate();
        },
    },
    mounted() {
        // mounted钩子函数在组件挂载完成后立即执行，而input输入框的值还没有更新
        this.$nextTick(() => {
            !this.globalModel.preview && formEventBus.$emit(FORM_EVENTS_TYPE.SEND_FORM_LOG, 'SHOW', 'COLLECT_INFORMATION_ITEM', this.logParams);
        });
    },
};
</script>

<style lang="less" scoped>
@import '../../style.less';
.mobile-general-form-input {
    /deep/ .form-content {
        justify-content: flex-end;
        .place-holder {
            display: flex;
            width: 100%;
            justify-content: flex-end;
            color: #9c9c9c;
            font-size: 16px;
            line-height: normal;
        }
    }
}
</style>
